import useAxios from "../../../Utils/useAxios";
import { deleteTransaksi } from "../services";
import ConfirmRemovalModal from "./ConfirmRemovalModal";

const DeleteTransaksiModal = ({
  isOpen,
  toggle,
  selectedTransaksi,
  refreshTransaksi,
}) => {
  const axiosInstance = useAxios();

  const handleDelete = async () => {
    await deleteTransaksi(axiosInstance, selectedTransaksi.id).then(() => {
      refreshTransaksi();
    });
  };

  return (
    <ConfirmRemovalModal
      isOpen={isOpen}
      toggle={toggle}
      handleDelete={handleDelete}
      label={"Anda yakin ingin menghapus transaksi yang dipilih?"}
    />
  );
};

export default DeleteTransaksiModal;
